export default i18n => [
    {
        path: `/${i18n.t('routes.login')}`,
        name: 'login',
        meta: {
            layout: 'Unauthenticated',
        },
        component: () => import(/* webpackChunkName: "login" */ '@/views/auth/Login.vue'),
    },
    {
        path: `/${i18n.t('routes.forgotPassword')}`,
        name: 'forgotPassword',
        meta: {
            layout: 'Unauthenticated',
        },
        component: () => import(/* webpackChunkName: "forgotPassword" */ '@/views/auth/ForgotPassword.vue'),
    },
    {
        path: `/${i18n.t('routes.resetPassword')}/:token`,
        name: 'resetPassword',
        meta: {
            layout: 'Unauthenticated',
        },
        props: true,
        component: () => import(/* webpackChunkName: "forgotPassword" */ '@/views/auth/ResetPassword.vue'),
    },
];